import { IUserObjectStore } from '../index'

export default function(state: IUserObjectStore): IUserObjectStore {
  return {
    ...state,
    settingsRequest: {
      ...state.settingsRequest,
      isSaving: true,
    },
  }
}
